export function textLimit(text: string, limit: number): string {
  return text.length > limit ? text.substring(0, limit) + '...' : text;
}

export function sanitize(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/gu, '')
    .replace(/[\p{P}\p{S}]/gu, '')
    .trim()
    .replaceAll(' ', '-')
    .toLowerCase();
}

export default { textLimit, sanitize };
